var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFalabella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 546,
    viewBox: "0 0 446 546",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M445.973 545.089H0V0H445.973V545.089Z",
    fill: "#C2D100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.146 229.78H194.586L199.192 212.426L222.613 119.553C229.82 93.2625 236.436 70.3586 261.037 51.1488C277.837 37.8775 299.734 30.3267 323.091 30.2639C323.091 30.2639 332.254 30.3267 338.013 30.9849L336.302 37.2157C336.302 37.2157 323.74 35.7772 316.062 37.2157C306.019 39.1755 300.21 42.5663 293.253 48.2275C280.442 58.6441 275.841 74.4964 267.686 102.877L239.077 213.273L234.766 229.78H319.797L316.584 239.265H232.252L183.34 425.443C176.188 451.704 169.517 474.619 144.971 493.844C128.039 507.152 106.029 514.71 82.4946 514.71L74.4939 514.558L75.8689 508.483C78.3195 508.539 81.056 508.483 83.2524 508.221C96.1679 506.712 105.108 503.092 112.705 495.227C124.812 482.595 130.095 470.448 138.309 442.101L192.085 239.265H114.928L118.146 229.78ZM291.865 294.912C291.865 284.525 302.171 276.12 314.945 276.12C327.666 276.12 338.013 284.525 338.013 294.912C338.013 305.295 327.666 313.73 314.945 313.73C302.171 313.73 291.865 305.295 291.865 294.912Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalabella);
export default __webpack_public_path__ + "static/media/Falabella.1e7419cf7491a187333c56ee8f80a859.svg";
export { ForwardRef as ReactComponent };